function Quotes(){
    return ( 
        <div className="text-center m-2"> 
            <div className="card w-1/2 bg-base-100 shadow-xl m-2 inline-block">
                <div className="card-body">
                    <h2 className="card-title">Jesse</h2>
                    <p>"Walton Habitat for Humanity has provided help and support for the community."</p>
                </div>
            </div>

            <div className="card w-1/2 bg-base-100 shadow-xl m-2 inline-block">
                <div className="card-body">
                    <h2 className="card-title">Arnav</h2>
                    <p>"I enjoy helping out and voluteering for Walton Habitat."</p>
                </div>
            </div>

            <div className="card w-1/2 bg-base-100 shadow-xl m-2 inline-block">
                <div className="card-body">
                    <h2 className="card-title">Harry</h2>
                    <p>"I love the work Habitat does for the community."</p>
                </div>
            </div>
        </div>
    )
}

export default Quotes;